import React, { useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { MessageMsgType } from '@tencent/dz-models';
import { useMessageById } from '../../../hooks';
import styles from './style/index.less';
import { ImagePreviewModal } from '../../../components';
import { formateImageWebp } from '../../../utils';
var CustomerMessage = function (props) {
    var messageId = props.messageId;
    var messageState = useMessageById(messageId);
    var message = messageState.payload.message;
    var _a = useComponents(), View = _a.View, Image = _a.Image;
    var _b = useState(false), showImagePreview = _b[0], setShowImagePreview = _b[1];
    var onShowPreview = function () {
        setShowImagePreview(true);
    };
    var onHidePreview = function () {
        setShowImagePreview(false);
    };
    return (React.createElement(View, { className: styles['customer-msg-wrapper'] },
        React.createElement(View, { className: styles['customer-msg'] },
            React.createElement(View, { className: styles['customer-msg-content'] },
                React.createElement(View, { className: styles['customer-msg-content-tail'] }),
                messageState.msg_type === MessageMsgType.Image ? (React.createElement(Image, { src: formateImageWebp(message), className: styles['customer-msg-image'], imageWidth: 100, imageHeight: 100, onClick: onShowPreview })) : (React.createElement(React.Fragment, null, message))),
            React.createElement(Image, { className: styles['customer-msg-avatar'], src: "//leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/chart_user.svg", imageHeight: 37, imageWidth: 37 })),
        messageState.msg_is_new && (React.createElement(View, { className: styles['read-state'] }, messageState.msg_read_status ? '已读' : '未读')),
        showImagePreview && (React.createElement(ImagePreviewModal, { images: [message], onHide: onHidePreview, defaultIndex: 0 }))));
};
export default CustomerMessage;
